import { makeObservable, observable } from 'mobx';
import { EventEmitter } from '../events';
import { Mutex } from '../synchronization';

export class Locker extends EventEmitter<{ releaseForFirstTime: null }> {
  private locks = 0;
  private hasReleased = false;
  private mutex = new Mutex();

  constructor() {
    super();

    makeObservable<Locker, 'locks'>(this, {
      locks: observable,
    });
  }

  get isLocked() {
    return this.locks > 0;
  }

  lock() {
    this.mutex.acquire().then(() => {
      this.locks++;
    });
  }

  unlock() {
    this.mutex.acquire().then(() => {
      this.locks--;
      if (!this.hasReleased && this.locks === 0) {
        this.emit('releaseForFirstTime', null);
        this.hasReleased = true;
      }
    });
  }
}

export const screenLocker = new Locker();
